import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation,
	ChangeDetectionStrategy,
} from '@angular/core';
import {
	AFTER_7_DAYS,
	AFTER_90_DAYS,
	SelectedDateRange,
	SUBTRACT_DAYS_FROM_TODAY,
	TODAY,
	TOMORROW,
} from 'cargo-chief-commons';
import moment, { Moment } from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';

@Component({
	selector: 'app-date-range-selector',
	templateUrl: './date-range-selector.component.html',
	styleUrls: ['./date-range-selector.component.scss'],
	encapsulation: ViewEncapsulation.Emulated,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeSelectorComponent implements OnInit {
	@Input() initialPickupStartDate: Moment = null;
	@Input() initialPickupEndDate: Moment = null;
	@Input() previousDateSelector: boolean = false;
	@Input() scorecard: boolean = false;
	@Input() scorecardDateRange: any = null;
	@Input() dateLimit: number = null;
	@Input() placeholder: string = 'Pickup date';
	@Output() dateSelected: EventEmitter<SelectedDateRange> = new EventEmitter();

	@ViewChild(DaterangepickerDirective) pickerDirective: DaterangepickerDirective;

	opens: string;
	selectedDates: string;
	minDate = TODAY();
	maxDate = TODAY();
	selected: { startDate: Moment; endDate: Moment };
	ranges: any = {
		Today: [TODAY(), TODAY()],
		Tomorrow: [TOMORROW(), TOMORROW()],
		'Next 7 Days': [TODAY(), AFTER_7_DAYS()],
		'Next 90 Days': [TODAY(), AFTER_90_DAYS()],
	};
	previousRanges: any = {
		Yesterday: [SUBTRACT_DAYS_FROM_TODAY(1), SUBTRACT_DAYS_FROM_TODAY(1)],
		'Last 7 Days': [SUBTRACT_DAYS_FROM_TODAY(6), TODAY()],
		'Last 30 Days': [SUBTRACT_DAYS_FROM_TODAY(30), TODAY()],
	};
	scorecardRange: any = {
		'Previous Week': [
			moment().subtract(1, 'weeks').startOf('weeks'),
			moment().subtract(1, 'weeks').endOf('weeks'),
		],
		'Last 7 Days': [SUBTRACT_DAYS_FROM_TODAY(6), TODAY()],
		'Last 30 Days': [SUBTRACT_DAYS_FROM_TODAY(30), TODAY()],
		'Last 90 Days': [SUBTRACT_DAYS_FROM_TODAY(89), TODAY()],
		'Previous Month': [
			moment().subtract(1, 'months').date(1),
			moment().subtract(1, 'months').endOf('month'),
		],
		'Previous Quarter': [
			moment().subtract(1, 'Q').startOf('Q'),
			moment().subtract(1, 'Q').endOf('Q'),
		],
		'Quarter to Date': [moment().quarter(moment().quarter()).startOf('quarter'), moment()],
		'Last Year': [
			moment().subtract(1, 'year').startOf('year'),
			moment().subtract(1, 'year').endOf('year'),
		],
		'Year to Date': [moment().startOf('year'), moment()],
	};
	locale: any = {
		format: 'M/DD/YYYY',
		applyLabel: 'Select',
	};

	constructor(private elRef: ElementRef) {
		this.opens = 'left';
	}

	ngOnInit() {
		if (this.scorecard) {
			this.previousRanges = this.scorecardRange;
			this.selected = {
				startDate: moment(this.scorecardDateRange.startDate),
				endDate: moment(this.scorecardDateRange.endDate),
			};
		} else {
			this.selected = {
				startDate: this.initialPickupStartDate,
				endDate: this.initialPickupEndDate,
			};
		}
	}

	ngOnChanges() {
		if (this.scorecardDateRange) {
			this.selected = {
				startDate: moment(this.scorecardDateRange.startDate),
				endDate: moment(this.scorecardDateRange.endDate),
			};
		} else {
			this.selected = {
				...this.selected,
				startDate: this.initialPickupStartDate,
				endDate: this.initialPickupEndDate,
			};
		}
		if (this.scorecard) {
			this.previousRanges = this.scorecardRange;
		}
	}

	open(e: any) {
		setTimeout(() => {
			this.pickerDirective.open(e);
		});
	}
}
